"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppDispatch = void 0;
var _reactRedux = require("react-redux");
var _useProps = _interopRequireDefault(require("./useProps"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAppDispatch = () => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    __instanceId
  } = (0, _useProps.default)();
  const modifiedDispatch = action => {
    var _instanceId$replace;
    return dispatch({
      ...action,
      instanceId: (_instanceId$replace = __instanceId === null || __instanceId === void 0 ? void 0 : __instanceId.replace(/-/g, '_')) !== null && _instanceId$replace !== void 0 ? _instanceId$replace : 'instance_id'
    });
  };
  return modifiedDispatch;
};
exports.useAppDispatch = useAppDispatch;